
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/deposits/[productGuid]",
      function () {
        return require("private-next-pages/product/deposits/[productGuid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/deposits/[productGuid]"])
      });
    }
  